/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Closedeal_Summary_Committedlps3Inputs */

const en_coinvestments_closedeal_summary_committedlps3 = /** @type {(inputs: Coinvestments_Closedeal_Summary_Committedlps3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organisations committed`)
};

/**
* | output |
* | --- |
* | "Organisations committed" |
*
* @param {Coinvestments_Closedeal_Summary_Committedlps3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_closedeal_summary_committedlps3 = /** @type {((inputs?: Coinvestments_Closedeal_Summary_Committedlps3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Closedeal_Summary_Committedlps3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_closedeal_summary_committedlps3(inputs)
});
export { coinvestments_closedeal_summary_committedlps3 as "coInvestments_closeDeal_summary_committedLps" }